var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details"},_vm._l((_vm.obsoleteList),function(schedule,index){return _c('schedule-info',{key:schedule.id,attrs:{"data":schedule,"title":`课程表-已结束${index+1}`},on:{"deletedSchedule":_vm.deletedSchedule}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }